/* CARQ theme behaviour: overlays, scroll reveal, cart, variant selection, search. */
(function () {
  'use strict';

  var theme = window.CarqTheme || {};
  var routes = theme.routes || {};
  var strings = theme.strings || {};

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function announce(message) {
    var region = $('#CarqLiveRegion');
    if (!region || !message) return;
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = message;
    }, 80);
  }

  function money(cents) {
    if (typeof cents !== 'number') return '';
    var format = theme.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withSeparator = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withSeparator + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withSeparator)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withSeparator)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withSeparator + ',' + parts[1]);
  }

  /* ---------------------------------------------------------------------
   * Overlays (menu, search, cart drawer)
   * ------------------------------------------------------------------- */

  var activeOverlay = null;
  var lastFocused = null;

  function focusableIn(root) {
    return $$(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])',
      root
    ).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function openOverlay(overlay, trigger) {
    if (!overlay) return;
    if (activeOverlay && activeOverlay !== overlay) closeOverlay();
    lastFocused = trigger || document.activeElement;
    overlay.dataset.open = 'true';
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    activeOverlay = overlay;
    var panel = $('[data-overlay-panel]', overlay) || overlay;
    window.setTimeout(function () {
      var first = focusableIn(panel)[0];
      (first || panel).focus({ preventScroll: true });
    }, 140);
  }

  function closeOverlay() {
    if (!activeOverlay) return;
    activeOverlay.dataset.open = 'false';
    activeOverlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    var overlay = activeOverlay;
    activeOverlay = null;
    if (lastFocused && typeof lastFocused.focus === 'function' && document.contains(lastFocused)) {
      lastFocused.focus({ preventScroll: true });
    }
    if (overlay.dataset.overlay === 'search') {
      var input = $('[data-search-input]', overlay);
      if (input) input.value = '';
      var results = $('[data-search-results]', overlay);
      if (results) resetSearchResults(results);
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-menu-open]');
    if (opener) {
      event.preventDefault();
      openOverlay($('#CarqMenu'), opener);
      return;
    }
    var searchOpener = event.target.closest('[data-search-open]');
    if (searchOpener) {
      event.preventDefault();
      openOverlay($('#CarqSearch'), searchOpener);
      return;
    }
    var cartOpener = event.target.closest('[data-cart-open]');
    if (cartOpener) {
      event.preventDefault();
      openOverlay($('#CartDrawer'), cartOpener);
      return;
    }
    var closer = event.target.closest('button[data-overlay-close]');
    if (closer) {
      event.preventDefault();
      closeOverlay();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && activeOverlay) {
      closeOverlay();
      return;
    }
    if (event.key !== 'Tab' || !activeOverlay) return;
    var panel = $('[data-overlay-panel]', activeOverlay) || activeOverlay;
    var items = focusableIn(panel);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ---------------------------------------------------------------------
   * Scroll reveal + header state
   * ------------------------------------------------------------------- */

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var items = $$('.reveal, .reveal-mask');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion || document.body.classList.contains('no-animations')) {
      items.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }
    );
    items.forEach(function (el) {
      if (el.classList.contains('is-in')) return;
      observer.observe(el);
    });
  }

  var header = $('[data-header]');
  function updateHeader() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();

  /* ---------------------------------------------------------------------
   * Cart
   * ------------------------------------------------------------------- */

  var cartDrawer = $('#CartDrawer');

  function drawerSectionId() {
    return cartDrawer ? cartDrawer.dataset.id : null;
  }

  function replaceDrawerSection(html) {
    if (!html || !cartDrawer) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-cart-drawer-body]');
    var current = $('[data-cart-drawer-body]', cartDrawer);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var freshTitle = parsed.querySelector('[data-cart-drawer-title]');
    var currentTitle = $('[data-cart-drawer-title]', cartDrawer);
    if (freshTitle && currentTitle) currentTitle.textContent = freshTitle.textContent;
  }

  function refreshCartDrawer(sections) {
    var id = drawerSectionId();
    if (!id) return Promise.resolve();
    if (sections && sections[id]) {
      replaceDrawerSection(sections[id]);
      return Promise.resolve();
    }
    // Safety net: ask for the section on its own if the cart response did not include it.
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        if (html) replaceDrawerSection(html);
      })
      .catch(function () {});
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (badge) {
      badge.textContent = count;
      if (count > 0) {
        badge.removeAttribute('hidden');
      } else {
        badge.setAttribute('hidden', '');
      }
    });
  }

  function refreshCartCount() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) updateCartCount(cart.item_count);
      })
      .catch(function () {});
  }

  function cartRequest(url, payload) {
    var body = Object.assign({}, payload);
    var sectionId = drawerSectionId();
    if (sectionId) {
      body.sections = [sectionId];
      body.sections_url = window.location.pathname;
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || strings.cartError || 'Cart error');
        }
        return data;
      });
    });
  }

  function setBusy(button, busy) {
    if (!button) return;
    if (busy) {
      button.setAttribute('aria-busy', 'true');
      button.classList.add('opacity-60');
    } else {
      button.removeAttribute('aria-busy');
      button.classList.remove('opacity-60');
    }
  }

  function addToCart(variantId, quantity, trigger) {
    if (!variantId) return Promise.resolve();
    setBusy(trigger, true);
    return cartRequest((routes.cartAdd || '/cart/add') + '.js', {
      items: [{ id: variantId, quantity: quantity || 1 }]
    })
      .then(function (data) {
        refreshCartDrawer(data.sections);
        refreshCartCount();
        announce(strings.itemAdded || 'Added to your bag');
        if (theme.cartType === 'drawer' && cartDrawer) {
          openOverlay(cartDrawer, trigger);
        }
      })
      .catch(function (error) {
        announce(error.message || strings.cartError || 'Cart error');
      })
      .then(function () {
        setBusy(trigger, false);
      });
  }

  function changeCartLine(key, quantity, trigger) {
    if (!key) return Promise.resolve();
    setBusy(trigger, true);
    return cartRequest((routes.cartChange || '/cart/change') + '.js', {
      id: key,
      quantity: quantity
    })
      .then(function (data) {
        refreshCartDrawer(data.sections);
        updateCartCount(data.item_count);
        // The cart page renders its own markup; reload it so totals stay authoritative.
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        }
      })
      .catch(function (error) {
        announce(error.message || strings.cartError || 'Cart error');
      })
      .then(function () {
        setBusy(trigger, false);
      });
  }

  document.addEventListener('click', function (event) {
    var quickAdd = event.target.closest('[data-quick-add]');
    if (quickAdd) {
      event.preventDefault();
      addToCart(quickAdd.dataset.quickAdd, 1, quickAdd);
      return;
    }
    var change = event.target.closest('[data-cart-change]');
    if (change) {
      event.preventDefault();
      changeCartLine(change.dataset.cartChange, parseInt(change.dataset.quantity, 10), change);
    }
  });

  /* ---------------------------------------------------------------------
   * Product form + variant selection
   * ------------------------------------------------------------------- */

  var productRoot = $('[data-product-root]');

  function upgradeImageUrl(url, width) {
    if (!url) return url;
    return url.replace(/([?&]width=)\d+/, '$1' + width);
  }

  function initProductForm() {
    if (!productRoot) return;
    var form = $('#CarqProductForm');
    if (!form) return;

    var variantsScript = $('[data-product-variants]', productRoot);
    var mediaScript = $('[data-product-media-map]', productRoot);
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var mediaMap = mediaScript ? JSON.parse(mediaScript.textContent) : [];

    var idInput = $('[data-variant-id]', productRoot);
    var priceEl = $('[data-product-price]', productRoot);
    var compareEl = $('[data-product-compare]', productRoot);
    var addButton = $('[data-add-to-cart]', productRoot);
    var addText = $('[data-add-to-cart-text]', productRoot);
    var stockEl = $('[data-variant-stock]', productRoot);
    var stickyText = $('[data-sticky-variant]', productRoot);
    var mobileAdd = $('[data-mobile-add]', productRoot);
    var mainImage = $('[data-product-gallery] img'); 
if (mainImage) {
  mainImage.removeAttribute('srcset');
  mainImage.removeAttribute('sizes');
}
    function selectedOptions() {
      var groups = $$('[data-option-group]', productRoot);
      return groups.map(function (group) {
        var active = $('[data-option-value][aria-pressed="true"]', group);
        return active ? active.dataset.value : null;
      });
    }

    function currentVariant() {
      if (!variants.length) return null;
      var selected = selectedOptions();
      for (var i = 0; i < variants.length; i += 1) {
        var options = variants[i].options || [];
        var match = options.every(function (value, index) {
          return selected[index] === null || selected[index] === value;
        });
        if (match) return variants[i];
      }
      return null;
    }

    function updateVariant() {
      var variant = currentVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;

      var meta = mediaMap.filter(function (entry) {
        return String(entry.id) === String(variant.id);
      })[0];

      var priceLabel = meta && meta.price ? meta.price : money(variant.price);
      if (priceEl) priceEl.textContent = priceLabel;
      if (compareEl) {
        if (meta && meta.compare_at_price) {
          compareEl.textContent = meta.compare_at_price;
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.setAttribute('hidden', '');
        }
      }

      var available = meta ? meta.available : variant.available;
      if (addButton) addButton.disabled = !available;
      if (addText) addText.textContent = available ? strings.addToCart || 'Add to bag' : strings.soldOut || 'Sold out';
      if (mobileAdd) mobileAdd.disabled = !available;
      if (stockEl) {
        stockEl.textContent = available ? 'In stock' : 'Out of stock';
      }
      if (stickyText) {
        var parts = [priceLabel];
        if (variant.title && variant.title !== 'Default Title') parts.push(variant.title);
        stickyText.textContent = parts.join(' · ');
      }

      if (meta && meta.featured_media_id && mainImage) {
        var thumb = $('[data-product-thumb][data-media-id="' + meta.featured_media_id + '"]', productRoot);
        if (thumb) {
          var thumbImage = $('img', thumb);
          if (thumbImage) mainImage.src = upgradeImageUrl(thumbImage.currentSrc || thumbImage.src, 1400);
        }
      }
    }

    $$('[data-option-value]', productRoot).forEach(function (button) {
      button.addEventListener('click', function () {
        var position = button.dataset.optionPosition;
        $$('[data-option-value][data-option-position="' + position + '"]', productRoot).forEach(function (sibling) {
          var active = sibling === button;
          sibling.setAttribute('aria-pressed', active ? 'true' : 'false');
          sibling.classList.toggle('border-ink', active);
          if (sibling.dataset.optionPosition === position) {
            var group = sibling.closest('[data-option-group]');
            var isSwatch = group && group.querySelector('[data-option-value] .sr-only');
            if (!isSwatch || !active) {
              sibling.classList.toggle('bg-ink', active && !isSwatch);
              sibling.classList.toggle('text-white', active && !isSwatch);
            }
          }
        });
        var label = $('[data-option-selected="' + position + '"]', productRoot);
        if (label) label.textContent = button.dataset.value;
        updateVariant();
      });
    });

    $$('[data-product-thumb]', productRoot).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var colourGroup = $$('[data-option-group]', productRoot).filter(function (group) {
          return group.querySelector('[data-option-value] .sr-only');
        })[0];

        if (colourGroup) {
          var position = Number(colourGroup.dataset.optionPosition);
          var buttons = $$('[data-option-value]', colourGroup);
          var alt = (thumb.dataset.mediaAlt || '').trim().toLowerCase();

          var colourButton = buttons.filter(function (button) {
            return button.dataset.value.trim().toLowerCase() === alt;
          })[0];

          if (!colourButton) {
            var linkedColours = [];
            mediaMap.forEach(function (entry) {
              if (String(entry.featured_media_id) !== String(thumb.dataset.mediaId)) return;
              var variant = variants.filter(function (item) {
                return String(item.id) === String(entry.id);
              })[0];
              if (variant && linkedColours.indexOf(variant.options[position]) === -1) {
                linkedColours.push(variant.options[position]);
              }
            });
            if (linkedColours.length === 1) {
              colourButton = buttons.filter(function (button) {
                return button.dataset.value === linkedColours[0];
              })[0];
            }
          }

          if (colourButton) {
            var selected = selectedOptions();
            selected[position] = colourButton.dataset.value;
            var combinationExists = variants.some(function (variant) {
              return variant.options.every(function (value, index) {
                return selected[index] === null || selected[index] === value;
              });
            });
            if (!combinationExists) {
              announce('This color is not offered in the selected size. Choose another size first.');
              return;
            }
            colourButton.click();
          }
        }

        $$('[data-product-thumb]', productRoot).forEach(function (sibling) {
          sibling.classList.toggle('ring-1', sibling === thumb);
          sibling.classList.toggle('ring-ink', sibling === thumb);
        });
        var image = $('img', thumb);
        if (image && mainImage) {
          mainImage.src = upgradeImageUrl(image.currentSrc || image.src, 1400);
          mainImage.alt = thumb.dataset.mediaAlt || '';
        }
      });
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var id = idInput ? idInput.value : null;
      if (!id) return;
      var quantityInput = $('[data-quantity-input]', productRoot);
      addToCart(id, quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1, addButton);
    });

    if (mobileAdd) {
      mobileAdd.addEventListener('click', function () {
        var id = idInput ? idInput.value : null;
        if (!id) return;
        addToCart(id, 1, mobileAdd);
      });
    }
  }

  /* ---------------------------------------------------------------------
   * Predictive search
   * ------------------------------------------------------------------- */

  function resetSearchResults(container) {
    var suggested = $('[data-search-suggested]', container);
    $$('[data-search-dynamic]', container).forEach(function (node) {
      node.remove();
    });
    if (suggested) suggested.removeAttribute('hidden');
  }

  function initSearch() {
    var overlay = $('#CarqSearch');
    if (!overlay) return;
    var input = $('[data-search-input]', overlay);
    var results = $('[data-search-results]', overlay);
    if (!input || !results) return;
    var timer = null;
    var controller = null;

    function render(products, terms) {
      resetSearchResults(results);
      var suggested = $('[data-search-suggested]', results);
      var wrapper = document.createElement('div');
      wrapper.setAttribute('data-search-dynamic', '');
      if (!products.length) {
        wrapper.className = 'mt-8 text-sm text-muted';
        wrapper.textContent = 'No pieces match "' + terms + '".';
      } else {
        wrapper.className = 'mt-8';
        wrapper.innerHTML =
          '<p class="eyebrow text-muted">Products</p>' +
          '<ul class="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">' +
          products
            .map(function (product) {
              return (
                '<li><a href="' +
                product.url +
                '" class="group block">' +
                '<span class="block aspect-square bg-paper"><img src="' +
                product.featured_image.url +
                '" alt="" class="h-full w-full object-contain" loading="lazy"></span>' +
                '<span class="mt-3 block text-[0.75rem] uppercase leading-snug tracking-[0.06em] group-hover:text-signal">' +
                product.title +
                '</span>' +
                '<span class="mt-1 block font-mono text-[0.6875rem] text-muted">' +
                product.price +
                '</span>' +
                '</a></li>'
              );
            })
            .join('') +
          '</ul>';
      }
      if (suggested) suggested.setAttribute('hidden', '');
      results.appendChild(wrapper);
    }

    function search(terms) {
      if (controller) controller.abort();
      controller = new AbortController();
      var url =
        '/search/suggest.json?q=' +
        encodeURIComponent(terms) +
        '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last';
      fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (data) {
          if (!data) return;
          var products =
            (data.resources &&
              data.resources.results &&
              data.resources.results.products) ||
            [];
          render(products, terms);
        })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var terms = input.value.trim();
      window.clearTimeout(timer);
      if (terms.length < 2) {
        resetSearchResults(results);
        return;
      }
      timer = window.setTimeout(function () {
        search(terms);
      }, 220);
    });

    $$('[data-search-suggestion]', overlay).forEach(function (button) {
      button.addEventListener('click', function () {
        input.value = button.dataset.searchSuggestion;
        input.focus();
        search(input.value);
      });
    });
  }

  /* ---------------------------------------------------------------------
   * Product recommendations
   * ------------------------------------------------------------------- */

  function initRecommendations() {
    var container = $('[data-recommendations]');
    if (!container || !container.dataset.url) return;
    fetch(container.dataset.url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-recommendations]');
        if (!fresh || !fresh.innerHTML.trim()) return;
        container.innerHTML = fresh.innerHTML;
        initReveal();
      })
      .catch(function () {});
  }

  /* ---------------------------------------------------------------------
   * Collection facets, sorting, sharing
   * ------------------------------------------------------------------- */

  function initFacets() {
    var toggle = $('[data-facets-toggle]');
    var panel = $('[data-facets-panel]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var open = panel.hasAttribute('hidden');
      if (open) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    var sort = $('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', function () {
        sort.form.submit();
      });
    }
  }

  function initShare() {
    $$('[data-share]').forEach(function (button) {
      button.addEventListener('click', function () {
        var data = {
          title: button.dataset.shareTitle || document.title,
          url: button.dataset.shareUrl || window.location.href
        };
        if (navigator.share) {
          navigator.share(data).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(data.url).then(function () {
            announce('Link copied');
          });
        }
      });
    });
  }

  /* ---------------------------------------------------------------------
   * Boot
   * ------------------------------------------------------------------- */

  function boot() {
    initReveal();
    initProductForm();
    initSearch();
    initRecommendations();
    initFacets();
    initShare();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initProductForm();
    initFacets();
  });
})();

/* CARQ gallery color synchronization — append to the END of assets/theme.js. */
(function () {
  'use strict';
  if (window.CarqGalleryColorSyncInstalled) return;
  window.CarqGalleryColorSyncInstalled = true;
  var reviewedPhotos = {
  "men-s-vintage-baggy-work-pants": {
    "e79960e8-3217-43c5-9dde-978c5a4f9972.jpg": "Brown",
    "e585fea9-d3f6-4c76-9de2-e67aff75ae0d.jpg": null,
    "aa86af51-c435-45bc-9ae7-29e755b2181c.jpg": "Dark Gray"
  },
  "men-s-frayed-seam-baggy-denim-shorts": {
    "d414f8a5-a7f9-4e33-87bd-0371f44ab0de.jpg": "Light Blue"
  },
  "men-s-distressed-panel-denim-shorts": {
    "c8996eba-70ee-4dc2-8b6c-1e53f356f667.jpg": "Retro Blue",
    "dc499253-b617-42f9-b091-1c509ad19294.jpg": null,
    "d92ef3a4-d3f7-4d64-a161-2e6e1bc9d864.jpg": "Light Blue"
  },
  "men-s-washed-baggy-denim-shorts": {
    "7c75df34-a16f-4301-84b6-fb076c8f0d59.jpg": null,
    "ec9119ec-9c6e-456f-bf7d-fbe8435d17e8.jpg": null,
    "e4b4eb9f-4e8b-433b-8fee-ebcf50a5fb8a.jpg": "Black And Gray"
  },
  "men-s-baggy-pinstripe-denim-shorts": {
    "452b4a7a-a414-4fca-9f56-3553f27c988a.jpg": "Light Blue",
    "68cca236-1309-4a89-b3c2-3edffd1c5ad6.jpg": "Light Blue",
    "02833828-6a35-4d16-b3ce-6edaf30bb693_fine.jpg": "Light Blue",
    "48b53ac7-1d6e-4399-8ed1-f1598d1e6533.jpg": "Light Blue",
    "d03bc16a-0e5c-4238-933d-4bb5b037b7ec.jpg": "Light Blue"
  },
  "women-s-contrast-seam-distressed-denim-shorts": {
    "1389174418364.jpg": "Black green",
    "1480390936351.jpg": "Black green"
  },
  "men-s-distressed-panel-wide-leg-denim-shorts": {
    "4acd9b42-059d-4253-8283-4f43c0811f81.jpg": "Light Blue",
    "3acd8a24-3747-4366-8926-6443f049e763.jpg": "Black",
    "ed5fdfd5-e965-4dd2-9188-c9792441cf86.jpg": "Light Blue",
    "dc6a1abd-9115-422d-900c-0888f7deeaec.jpg": "Black",
    "b9ed55bc-1272-476a-85bb-6d25925c296f.jpg": "Black"
  },
  "men-s-baggy-ripped-denim-shorts": {
    "beb64ba0-a757-432e-880b-98bcb04daa4d.jpg": "Black",
    "8a6e95ff-ba2f-4f39-a302-06e8361d18ae.jpg": null,
    "c23a2551-0bd0-4d03-9e26-b6d377588724.jpg": "Yellow Mud Colors"
  },
  "unisex-high-collar-zip-up-jacket": {
    "051d5b7c-5fca-4d36-8288-61f91b5fbc1b_trans.jpg": "Purple",
    "94672da1-7b11-4c61-8068-147b1b96a25c_trans.jpg": "Apricot",
    "8c8ba11d-8bc6-4993-937c-dae6182b87e5_trans.jpg": "Black",
    "11fd4d67-af6f-424f-8099-69bb7c14ae4c.jpg": "Purple",
    "4ab297f3-094c-4190-9e61-204b04c21451_trans.jpg": "Black"
  },
  "unisex-racing-graphic-zip-up-hoodie": {
    "7b8a99d4-38a1-4f41-a157-4271d00a9e6b.jpg": "Green",
    "01a65ef2-c80f-48eb-8906-9660cc53e484.jpg": "Black",
    "8a73e06f-89bc-46d2-bb2e-9f22e037528e.jpg": null
  },
  "men-s-vintage-wash-zip-up-hoodie": {
    "f3638349-2069-40dc-99ad-bbdf926c7b7f.jpg": "Gray",
    "2fdf5db2-5299-4735-b588-47d13fba93ab.jpg": null
  },
  "men-s-star-embroidered-denim-jacket": {
    "4e09f786-4cbf-4423-990e-152941988df6.jpg": "Rust Red",
    "2c3d0485-1e28-409d-a9e1-4069698f56f9.jpg": "Rust Red",
    "3329c042-75ab-4215-806e-373abca035c0.jpg": "Rust Red",
    "b8253df4-9618-40cc-a60c-4b2a6165ebe4.jpg": "Rust Red",
    "2cd9d9f7-55ea-4f85-8420-49fdda53e71d.jpg": "Rust Red",
    "bb630dd8-8763-4949-ae71-4aa5bef8c65b.jpg": "Black"
  },
  "men-s-star-embroidered-zip-up-jacket": {
    "6891792f-677e-4e16-8236-610d11d669df.jpg": "Khaki",
    "45a7a924-2663-4093-9958-f62880f5df5a.jpg": null,
    "3e039c52-2259-4497-9e30-497105d11d7d.jpg": "Black",
    "639d1c45-eb45-41c0-ae38-b6759012c29c.jpg": "Khaki",
    "40a01111-075a-41ef-b6d1-cc2aa39e8aa6.jpg": "Khaki",
    "ac4b2d2c-2820-4c68-b8db-5e946f3274dc.jpg": "Black"
  },
  "unisex-oversized-embroidered-varsity-jacket": {
    "683b7891-fafc-4dcd-88df-208a7bdd2ee5.jpg": "Black",
    "1ca1826c-81f8-418b-a4e7-b4d849a208c1.jpg": "Black",
    "769627de-9300-454a-9a7f-90f255187eba.jpg": "Black",
    "c746f049-9107-415e-b59d-d8e6517de24d.jpg": "Black"
  },
  "men-s-quilted-letter-bomber-jacket": {
    "c5f17e1e-a0fd-4d13-a28b-de307eae0e42.jpg": "Green",
    "1f7d557d-cb61-48c6-b4d3-e9806a72aefd.jpg": null,
    "319bc9f1-3175-47dc-9d89-4424b3f0e17d.jpg": null,
    "1cadd1fb-83ac-405f-a825-bfe71aec072b.jpg": "Black",
    "c5954df3-fcc5-4b24-91e9-a946f78d97d5.jpg": "Black",
    "faf08c84-bdde-4100-9bb9-544dfb21b26b.jpg": "Black",
    "fcc1f146-ba8f-4854-a8e0-f8c8b0875677.jpg": "Black"
  },
  "men-s-oversized-hooded-denim-jacket": {
    "6ac6df8c-3e33-4258-a52e-93a5fc8028e7.jpg": "Black",
    "ee7ea546-865e-418d-9724-c49b91a8b085.jpg": "Black",
    "6e8ac2ea-54db-4cba-baa2-bf1fce83e898.jpg": "Green Camouflage",
    "3ec214bc-dcfd-4d07-be53-f7ebdf748ff1.jpg": "Black"
  },
  "unisex-abstract-print-denim-jacket-jeans-set": {
    "350db0fa-5b0e-4e4a-bc5b-4bfb796439fa.jpg": null,
    "44419d92-8e1d-4305-9c06-65df80b57816.jpg": "Yellow Coat",
    "2e56602c-4dce-4261-a2a9-048b8c18ca2a.jpg": null,
    "aeac5c03-e044-43e9-b7dd-6fe2dd54a6b3.jpg": "Yellow Pants"
  },
  "men-s-retro-embroidered-varsity-jacket": {
    "da5cd185-ac2b-4569-a623-ab761bda20ac.jpg": "Brown",
    "c7dd5042-2fda-4d2b-9b21-b14d633345f4.jpg": "Brown",
    "12487a68-2a45-49aa-b102-3372f93b4597.jpg": "Brown",
    "da3b62aa-0187-47a7-bbc6-c3f5f5eab4e1.jpg": "Brown",
    "7341aaf0-fdad-4360-863b-1264dd1c3afb.jpg": "Brown",
    "4bc6e4a3-8f7f-498f-bc9d-a45897a15d4e.jpg": "Brown"
  },
  "men-s-wave-panel-faux-leather-jacket": {
    "165218f3-0b68-4116-9742-58466458d65c.jpg": "Red",
    "63aac33c-95d9-434d-9756-4b869e09667e.jpg": "Beige Apricot",
    "fdabd19e-14fc-407c-b244-0ec5adad8ae6.jpg": "Beige Apricot",
    "ff319b6a-72f8-4e0d-abc7-29af9a3d1295.jpg": "Black",
    "e4e3e011-2129-4bc2-8ced-eda083682e09.jpg": "Beige Apricot",
    "ebcf225b-ce37-4161-a69b-169dac2527d3.jpg": null,
    "921efaf1-bca8-49cb-b01d-5ab24e102de8.jpg": "Beige Apricot"
  },
  "men-s-retro-contrast-collar-denim-jacket": {
    "33b27bd4-3a7b-426a-bab9-24128a7b676a.jpg": "Blue",
    "1742753227344056320.jpg": "Blue",
    "c83aec01-ebcc-4535-837b-1b7585d90cf9.jpg": "Blue",
    "1742753227780263936.jpg": "Blue"
  },
  "men-s-contrast-stripe-zip-up-shirt-shorts-set": {
    "2bc077e2-fb40-4101-99ff-430286e9968c.jpg": "LS Zipper Shirt Outfit 1"
  },
  "men-s-star-zip-up-shirt-shorts-set": {
    "3038fb2f-f2fd-42d4-b05c-d54d38cd80e2_water.jpg": "7 Khaki",
    "322fa0ce-7703-44fa-902e-9ed99f01f9d9_water.jpg": "5 Yellow",
    "88cbd4be-909c-4beb-962e-db6c58b3b748_water.jpg": "8 White"
  },
  "men-s-washed-distressed-loose-fit-t-shirt": {
    "6f48bfcd-1355-475e-8fec-d05211e2befe.jpg": "Black",
    "13b57e43-4970-4790-a550-6967477aa39f.jpg": null
  },
  "men-s-black-retro-raglan-graphic-shirt": {
    "2436534c-e3cc-4a08-a53d-0170994d6094_9ed34088-b0dd-4238-96e6-3f268e17d350.jpg": "Brown NZKS103 SUCK",
    "bcbb84a9-d72d-4045-8b22-86039c197630.jpg": null,
    "83339fce-8284-4f21-957e-0157d3c1ef4b.jpg": "Black NZKS103 SUCK",
    "1741339585755090944.jpg": "Brown NZKS103 SUCK"
  },
  "men-s-striped-lace-up-short-sleeve-polo": {
    "c97b8598-d4d0-4981-8a0f-bc99ed0a97ac.jpg": "Yellow",
    "b83765fc-95f3-476d-afe1-0eb8b2373413.jpg": "Yellow",
    "9eb9b925-eb4b-432b-8852-af7e255c15f4.jpg": "Yellow",
    "fcb5089e-7977-40d9-963c-21ad76c7d3ba.jpg": "Red"
  },
  "men-s-deconstructed-wide-leg-denim-shorts": {
    "0398aa0f-4c6d-4e57-a2a3-c9e438efd4f8.jpg": "Light Blue",
    "654720b0-c029-4bfa-9f82-0b268bb267a5.jpg": "Light Blue",
    "06e6552c-208a-49b8-ab6d-fbde8c963982.jpg": "Dark Blue"
  },
  "men-s-washed-loose-fit-denim-shorts": {
    "6bf2b530-650a-4b29-8ec3-0b927424c952_fine.jpg": "Black",
    "a147109f-491c-4cd8-8cd6-9a9adbbb7139_fine.jpg": "Black",
    "35a9281b-484f-4fb0-b1be-4200b2e49789_fine.jpg": "Black",
    "aa5c488f-ae9d-4c0a-b8dd-f551f4a851c1_fine.jpg": "Black"
  },
  "ash-washed-paint-splatter-hoodie": {
    "5511eee2-07a0-4680-8811-d84e3d537f2f.jpg": null
  },
  "distressed-star-and-crescent-washed-hoodie": {
    "2f8e8d2e-18d8-4fb6-8e0b-b6cd5989bc2d.jpg": "Batik Gray",
    "08e7b48b-2e69-40b4-b925-e43a1aab4517.jpg": "Batik Gray",
    "e2c256d0-dc04-4399-be30-e7bcc6e6e6f1.jpg": "Batik Gray"
  },
  "celestial-butterfly-graphic-hoodie": {
    "0211021a-834f-4f2f-8190-79587acc449a.jpg": "Gray",
    "543b2519-0ed1-49fb-9124-c8714ab41a24.jpg": "Gray"
  },
  "see-you-again-graffiti-hoodie": {
    "6935ee22-dc3f-4a1a-b73f-17e3fae0590b.jpg": null,
    "b19748a9-febf-4c42-a418-066cf0574b09.jpg": "Red",
    "8abe5430-05bb-4a35-932c-c2a4fa8edddf.jpg": "Red",
    "f6bd205b-16fd-410b-a4d0-86d9a718ba2a.jpg": "Red"
  },
  "washed-wide-leg-denim-jorts": {
    "0fc6c065-4974-4378-8582-593147a77198.jpg": "Blue",
    "77451219-6835-4f41-8e54-7945a6f511b7.jpg": "Black",
    "86c9ba76-ae14-4d72-9523-857c8275a1be.jpg": "Retro Blue"
  },
  "red-washed-doodle-graphic-hoodie": {
    "931f07b3-421f-4d52-b820-adee307153f0.jpg": "Washed Black",
    "7bf576f6-abd6-4822-9e7a-9294b631d32e.jpg": "Brick Red"
  },
  "the-world-paint-bucket-washed-long-sleeve-tee": {
    "1fc229aa-e252-47cf-9a42-58e059a4c851.jpg": "Red",
    "29107c48-406f-497a-b28e-cae86dffae9b.jpg": "Black"
  },
  "blue-colorblock-short-sleeve-polo-shirt": {
    "4edc4edd-1edc-4aab-9f05-68ac824113b8.jpg": null,
    "5c3836ac-499d-4334-8bf1-bfa4e6ce503d.jpg": "Olive",
    "4a9d6f51-1d20-44b5-9f77-556983d8b1cd.jpg": "Dark Blue",
    "ed3c192c-5303-42fa-9e1b-3a3856d8d666.jpg": "Light Blue"
  },
  "blue-plaid-embroidered-button-up-shirt": {
    "57647991-1864-4f36-b336-b08ad5735abd.jpg": "Blue",
    "1acf7623-40d5-42d8-a5d8-c29982810d02.jpg": "Pink",
    "2105d464-debe-4824-926e-c892d5e6ccc1.jpg": "Blue",
    "10d2ef66-f502-4ec4-9bd3-53e07606b9cb.jpg": "Blue",
    "e13b799b-868a-4a02-b6b5-e6361c94ac49.jpg": "Blue"
  },
  "make-true-dream-graphic-t-shirt": {
    "55c62685-16ac-423d-809c-d3de0fb5eccf.jpg": "Dark Gray"
  },
  "god-has-a-plan-washed-graphic-t-shirt": {
    "a75bc54d-a18a-40af-ae39-6384cb3b718d.jpg": "Black",
    "7e512f35-1695-4d60-bc32-b8a3ffcf82bf.jpg": "Black",
    "76bc6fc7-403e-42e6-8e76-19653dc6ad9f.jpg": "Black"
  },
  "freedom-of-thought-washed-graphic-t-shirt": {
    "07332197-ffe6-4993-ab69-9446b074c4a8.jpg": "Gray",
    "94719518-48de-4ff4-8b0a-4e5783d398fc.jpg": "Gray",
    "eae86007-8b30-4ddb-8cf6-9e105d2ad954.jpg": "Purple"
  },
  "washed-splatter-graphic-t-shirt": {
    "31cffe27-d25d-4f14-a368-67ab99aaf1cd.jpg": "Black",
    "719902c5-7dff-4348-96cb-3f55e16a819d.jpg": "White",
    "f20e38fd-89fc-4e5e-ba2a-15a9126f3175.jpg": "White",
    "b55d1850-23bc-440e-aee8-0253e2a217f7.jpg": "Army Green"
  },
  "washed-tower-graphic-t-shirt": {
    "55acfb4c-1e0f-4ece-8f16-00cf58c80874.jpg": "Pink",
    "89acd388-be44-41c1-9c3a-781a3783872c.jpg": "Blue"
  },
  "distressed-washed-graphic-hoodie": {
    "18102e6f-3023-4eb7-a54c-4cd549d1d3ac.jpg": "Brown",
    "7a962c50-a474-4e75-b463-74c89a256175.jpg": "Brown",
    "538ba396-9fea-4738-a105-47666fb5e93d.jpg": "Brown",
    "f0240677-ec3b-4cb3-9c7c-ea4f97ddd731.jpg": "Brown"
  },
  "embroidered-color-block-half-zip-sweatshirt": {
    "312c871b-76fc-4b28-8ae6-2988f20b4f5f.jpg": "Royal Blue",
    "2401100034050327600.jpg": "Black",
    "e4d4bbf9-3668-44fc-9721-8f21c99fbdf3.jpg": "Royal Blue"
  },
  "retro-color-block-long-sleeve-polo": {
    "4c1270f1-9406-4d86-9cc4-d2b94168db4f.jpg": "Red",
    "4807bc49-aa1b-4903-899f-07cb53580c97.jpg": null,
    "90d075e6-0aeb-48d2-a37f-06699273fece.jpg": "Black"
  },
  "god-is-good-graphic-zip-up-hoodie": {
    "ebc23b33-7170-4e92-b055-45d1b9342e31.jpg": "Black",
    "d98bd51b-ac01-471c-94f7-1212a8848379.jpg": "Black"
  },
  "diagonal-graphic-zip-up-hoodie": {
    "839e5429-57b8-48c3-b4e0-4d75959cb0b4.jpg": null,
    "f329849b-1f9c-4a3f-a448-1e6f29e149ad.jpg": "Black"
  },
  "romantic-patchwork-crewneck-sweatshirt": {
    "2401170254510321800.jpg": "Green"
  },
  "washed-vintage-zip-up-hoodie": {
    "b0868221-3010-47a9-8a29-adaff42227b8.jpg": null,
    "e048bf4e-c853-4579-9d21-4de2c9375013.jpg": null
  },
  "two-tone-patchwork-fleece-hoodie": {
    "5d207651-87a3-4b70-8574-b983dde33791.jpg": "Apricot",
    "292a1d21-155c-4efd-b00a-845ec3a11e25.jpg": null,
    "0bfc7285-83c3-4f8a-81fc-891d10b87827.jpg": "Apricot"
  },
  "washed-gradient-pullover-hoodie": {
    "c620c945-e1ef-4e6a-9570-b0d946b614a0.jpg": "Gray Blue"
  },
  "butterfly-embroidered-zip-up-hoodie": {
    "ee0d0c01-2f54-477b-949f-44a1a9e7cceb.jpg": "Apricot",
    "fa440e22-04d7-4d2c-af48-30ab0eaa3ffc.jpg": "Apricot"
  },
  "embroidered-graphic-zip-up-hoodie": {
    "2d667b2b-850d-4bd0-a982-a4cdd4e960cf.jpg": "Red",
    "1aa4e46a-3455-4d40-832d-3c43a8f511c6.jpg": "Black",
    "24e391a6-51a0-4569-8b94-91f08ebacf5d.jpg": "Gray",
    "52aa85d4-a142-4267-a282-276ab9fb37b7.jpg": "Blue"
  },
  "unisex-black-wide-leg-jeans": {
    "e4965ba5-b414-40a8-82ac-8071d9adaf54.jpg": "Black curved blade style",
    "7d9e6f74-a7c9-412c-b5b3-40568da575e2.jpg": "Black curved blade style"
  },
  "men-s-mud-washed-distressed-wide-leg-jeans": {
    "ad2986ce-7b9f-4cd2-88ed-f78125e225eb.jpg": null
  },
  "men-s-printed-zip-up-hoodie": {
    "15cd3871-f9e9-4571-8674-9c6c397ac546.jpg": "White",
    "0fc6005c-e142-4f50-aa09-b828cf380822.jpg": "Black",
    "27be0533-6ba8-4c66-95c6-e529fff9c641.jpg": "White"
  },
  "men-s-minimal-zip-up-vest": {
    "2717e0a2-e49d-4d30-905b-40fcc3da5e65.jpg": null,
    "85bff77b-1a38-4ad5-8123-635859f2b73c.jpg": null,
    "c8e70763-8179-4fad-ad44-77509f2d23c2.jpg": null
  },
  "men-s-star-graphic-zip-up-hoodie": {
    "26f61626-9e58-4b9b-a086-0fe5a4a8d671.jpg": "Black"
  },
  "men-s-retro-patchwork-denim-shirt-shorts": {
    "362bc190-6a61-4547-8cbf-3b7096ba50ae.jpg": null,
    "e3d2eece-8aca-4a03-8bdf-9d605c398312.jpg": "Blue Pants",
    "b58459b7-3d82-4eb9-81cf-54aad082542f.jpg": "Blue Coat"
  },
  "men-s-embroidered-back-plaid-shirt": {
    "d0c0e0fe-0f7f-4842-b596-27531a781e15.jpg": "Brown",
    "d6df502f-3d3b-4640-a448-0536e1e7fe6d.jpg": "Black",
    "3b08c391-8255-4d21-8659-6c917d831c12.jpg": "Brown",
    "6eb8ad62-b4d7-45a2-8a30-fe5513232840.jpg": "Brown"
  },
  "men-s-washed-gradient-short-sleeve-denim-shirt": {
    "a1112eab-2ce6-4b3f-ad17-34b4566bb17c.jpg": "Blue",
    "c650824c-8c58-428f-ab78-ad9c885f2f9a.jpg": "Black",
    "5e4493ae-e151-480c-8b94-096f843ee3be.jpg": null
  },
  "men-s-contrast-collar-graphic-polo-shirt": {
    "ec6ce685-0d9f-4338-9e57-027900ee8e93.jpg": "Black",
    "daba41cb-6fd3-42c2-9951-1da0b46e108f.jpg": "White",
    "8bec1072-2f96-4f97-95a8-84395cd79f0e.jpg": null
  },
  "men-s-washed-god-will-never-fail-you-graphic-t-shirt": {
    "df346ac1-aff6-4653-8c71-404a00f82314.jpg": "Gray",
    "9f3cc33e-91bb-43d0-987b-1cba1594e71f.jpg": "Brown",
    "dba9c98d-3d82-42ce-8278-324ecafade10.jpg": "Purple"
  },
  "oversized-embroidered-pocket-shirt": {
    "59b87b3e-2d3b-49db-86da-1e24399df37e.jpg": "Black",
    "6ea630fd-4ab7-4d8f-8a10-b5fcb7473c72.jpg": "Black",
    "669036a6-ab3e-4f1d-9ba0-d713e1e3c558.jpg": "Khaki",
    "88b43c2c-0b72-48ec-9a08-4a1b5a8bd993.jpg": "Khaki"
  },
  "men-s-metal-label-loose-fit-shirt": {
    "f2e328e5-7be4-4f78-866d-33c14df292d5.jpg": "Gray",
    "0f4bfae1-bba6-4aaa-bd5b-1d8fd7b3e47a.jpg": "Gray",
    "6d0c3977-1afd-4c4e-96d9-f4e9b7dac5a0.jpg": "Gray"
  },
  "loose-fit-half-sleeve-top": {
    "2390736f-4338-4843-8292-2aa7001fb4be.jpg": null
  },
  "loose-fit-streetwear-jacket": {
    "b50a493a-5670-4381-b972-a3a415d3d1bf.jpg": "Purple",
    "8a907a19-cfe2-4f7b-a0f2-7f4a94f62308.jpg": "Purple"
  },
  "men-s-3d-print-loose-fit-t-shirt": {
    "ed487b00-c828-4144-a546-083cc72c6554.jpg": "Coffee"
  },
  "vintage-wash-leaf-print-long-sleeve-shirt": {
    "a0e3b5b4-73e2-4de7-97c2-c63edf5b12a8_water.jpg": null
  },
  "vintage-rose-embroidered-short-sleeve-shirt": {
    "fec2b430-ad90-4734-b8b0-ea2cc5b65e11.jpg": null,
    "d852400b-a347-4aef-952a-905e1e4a5ca2.jpg": "Black",
    "d6f5e22d-52ef-4605-90fb-d5b16b731600.jpg": "Apricot"
  },
  "men-s-alphabet-embroidered-t-shirt": {
    "2bfcb78f-122a-47af-9288-33f0732506ea.jpg": null
  },
  "retro-distressed-loose-fit-t-shirt": {
    "b8708aee-93ee-4e18-a7a1-09dcb6646e9d.jpg": "Gray",
    "29b8fb3f-1b1d-46c5-bf47-72911a72f984.jpg": "Black",
    "6abd2562-2fbd-434c-b97e-e0fac6c9e117.jpg": null
  },
  "vintage-wash-polo-collar-sweater": {
    "9e03f6e8-928e-47ea-889c-3d2f417ca2d5.jpg": "Deep Coffee"
  },
  "men-s-oversized-plaid-shirt": {
    "2d1368cd-01c7-4ce8-8b1b-d6afed6b5888.jpg": "Pink",
    "de4fdf71-05b7-4b00-adc5-33b054d78ae0.jpg": "Yellow",
    "4d1f8fe7-3497-465a-8daa-c0cd819bf85f.jpg": "Pink",
    "22f2875b-4876-4a94-a014-64379162da3a.jpg": "Yellow",
    "5a3b48b5-9e28-4d58-94b2-8e8e065a4c12.jpg": "Yellow"
  },
  "men-s-vintage-embroidered-t-shirt": {
    "566b1b58-6838-4c0e-a102-9727a4747bd1.jpg": null,
    "7578c0c1-4c19-41f1-aa13-21b752c3728e.jpg": "Black",
    "416bf2a9-4443-46ec-8719-dc82de6996d0.jpg": "Dark brown",
    "eef9210f-0117-4bcd-a1f5-d1ba81507a26.jpg": "Grey"
  },
  "men-s-heavyweight-distressed-t-shirt": {
    "f4e9d350-80a5-4076-899f-4ed138e40eb4.jpg": null,
    "f0257d72-cb2a-4b0d-b18e-c6b3d758a757.jpg": "Black Grey Apricot",
    "a69f809d-9e3a-4e49-b5e6-50080864e167.jpg": "Suit  2",
    "8436237f-861b-4243-a2f8-24719e69b719.jpg": null
  },
  "men-s-floral-short-sleeve-shirt": {
    "624095e0-2b4a-470d-8bc9-4bae3644d981.jpg": "04 Style",
    "b9711b4e-d852-4190-9047-fcf87229404e.jpg": "01 Style",
    "b5fd2d99-01cd-4c77-bf62-6c27712a9ee8.jpg": "05 Style",
    "9d6724c7-b1dd-4283-abf0-7b5b138b9db6.jpg": "03 Style"
  },
  "men-s-loose-fit-short-sleeve-shirt": {
    "7c374349-b782-4f7d-b837-7f83433a6ad8.jpg": "Purple",
    "7c767e12-36e9-417b-9bb2-86a212e5f850.jpg": "Purple",
    "00b2204a-dc4a-41dc-8e43-ba8c0cac872b.jpg": "Purple"
  },
  "retro-front-detail-streetwear-pants": {
    "929eb135-2632-4204-b717-840c444dc9dd_fine.jpg": "Tea Green",
    "eb9d6b3a-c755-4228-926e-2da6fec10bf5_fine.jpg": "Black",
    "14cd636a-94de-4178-b779-3522313917da.jpg": null,
    "7cd167c5-6cf6-4125-8c19-86602e1658be_fine.jpg": "Black"
  },
  "women-s-high-rise-sports-jumpsuit": {
    "56ab9b4c-4485-44ab-9d73-717bbbb00eb4.jpg": null,
    "b6c49186-a0a8-4b54-beb2-112dfe52910d.jpg": "Pink"
  },
  "men-s-streetwear-zip-up-hoodie": {
    "a4816f3b-3fe4-4883-8a1b-32869b81c1ac.jpg": "Gray",
    "f4d1a9c1-a132-4fdd-872b-be4ecacbde84.jpg": "White",
    "3bf7e806-e70e-4627-b779-042f44c92d75.jpg": null
  },
  "women-s-letter-detail-denim-shirt": {
    "20291ab8-fe11-47ff-9330-2753fcad203f.jpg": "LS3117 Gray",
    "ddfe1b4c-accd-4d26-9359-482624a942d7.jpg": "LS3117 Gray",
    "5a610211-a2c4-4927-805b-44f2cfc11276.jpg": "LS3117 Gray",
    "163b113f-c31b-4dad-9df7-9b7fbf8d13fb.jpg": "LS3117 Blue"
  },
  "retro-lace-embroidered-baggy-jeans-1": {
    "5aaed1e6-1ef4-4af5-be6d-ae93c6a7eafe.jpg": "Blue And Yellow",
    "a3ec35bd-2f6c-4699-bbe7-ca943640a50c.jpg": "Blue And Yellow",
    "0ab6a68d-ffe9-4b43-9ca2-ab8c740d223e.jpg": "Blue And Yellow",
    "a4b27e0b-5339-4cff-9c20-c57657322893.jpg": "Blue And Yellow"
  },
  "men-s-distressed-dirty-wash-jeans": {
    "1b32b331-8d29-4d45-9382-1b8f511d8631.jpg": "Black",
    "c5e25ece-8839-4989-bfec-5bb2dbda0f9d.jpg": "Black",
    "6dc9a8ad-829d-4f51-87f3-102a18783de1.jpg": "Black",
    "a767a946-3b05-48a3-93b3-49374f2369c6.jpg": "Black"
  },
  "men-s-american-design-straight-leg-jeans": {
    "15f4d655-6a41-4647-8523-ad51fae16dad.jpg": "Black And Gray",
    "8fcbf82b-d55f-4f68-9a4b-f23eaee0c03f.jpg": "Black And Gray",
    "330a79d3-2437-496b-a81d-dcdcabbeca9a.jpg": "Dark Blue",
    "7942fb4a-f716-4401-955a-319458b69fbc.jpg": "Black And Gray"
  },
  "men-s-heavy-wash-streetwear-pants": {
    "c3d3e8ba-6188-46e8-a118-89026ca26db3.jpg": "Green",
    "94b80a32-9e66-4413-afba-bf912c3e4e49.jpg": "Green",
    "79af429f-401a-4fd1-8ed7-8f4316fdde98.jpg": "Green"
  },
  "men-s-high-street-camouflage-jeans": {
    "0ad8bb14-4f03-4902-8079-fb74ba8da2e0.jpg": "White",
    "bf53e9dc-4db8-4c7b-ba98-3eec69f37c68.jpg": "Black",
    "6b496894-cb54-4fd5-908e-67b5d7655269.jpg": "Black",
    "f854a7b3-504c-4f80-a3d2-a696aef97039.jpg": "Black",
    "10a3b68a-db66-46d5-9d15-1119853a24cf.jpg": "Black",
    "fe72db8f-959b-4b90-9c6b-7cc6db7c0a16.jpg": "Black"
  },
  "men-s-high-street-loose-fit-t-shirt": {
    "3ed3d629-6db8-496d-a56e-680d7cacd280.jpg": null,
    "35cb6ffb-46da-4983-bd3a-3976a4ca2b53.jpg": "Gray",
    "7c54f719-9513-4007-a087-2adb204cda57.jpg": "Gray"
  },
  "high-street-streetwear-jeans": {
    "a57f0e70-1a1b-4d01-bac9-6a11894e62e5.jpg": null,
    "5dab16f3-a50f-4cf0-af45-af17fc300322.jpg": "Black",
    "952f5de2-a236-4fb2-8bd5-e1896cd09fcc.jpg": "Black",
    "cdd9a640-f87f-40e7-ac87-acf9a82e0eb8.jpg": "Light Blue"
  },
  "women-s-buttoned-tie-waist-blouse": {
    "6aee2b5b-6edb-4e5e-8f21-1aa9d017c5fd.jpg": "Light Blue",
    "513e7024-a4db-4b48-ab25-f0cb48e3d6ea.jpg": "Wine Red",
    "7f4bc01f-5341-487e-bb12-8a9a4fdc9689.jpg": "Wine Red"
  },
  "women-s-deep-v-neck-halter-mini-dress": {
    "047d4f6f-e3cd-47b3-ada1-e632dd94dd87.jpg": "Apricot",
    "5f8457be-42c0-461f-9d63-1f6ed087a409.jpg": "Black",
    "cfacc740-2c83-4d38-84c3-050b6e0e99fc.jpg": "Black",
    "31f9e1c6-a23a-444f-b5b9-217a6fa5d310.jpg": "Apricot",
    "c758d912-ef51-4cac-aa0c-fb5856b0f272.jpg": "Apricot"
  },
  "women-s-knitted-turtleneck-two-piece-set": {
    "8e6be548-fd83-426e-9b03-6097a4944424.jpg": "White",
    "0e6048bb-e9df-42a1-b94f-482c9798e3d3.jpg": "Black"
  },
  "women-s-drawstring-halter-crop-top": {
    "0ef6e49a-b01b-4bb7-8d51-f9f2ca47f9da.jpg": "Black",
    "bde22542-8373-4a64-94a2-cf75954b215e.jpg": "Black",
    "fbf9bd7a-d027-4c74-8021-ad2b48751956.jpg": "Black",
    "6ef39d2d-eae0-4b69-9073-266929a0170e.jpg": "Black",
    "e9be28cf-1cf6-45cb-83cb-bc8120170cb7.jpg": "Black"
  },
  "women-s-graphic-cropped-tank-top": {
    "7c315a40-4339-4013-b16b-a56ca5723f8a.jpg": "Royal Blue",
    "8ed772fb-4fbe-45ba-9e30-0ca947c3b10e.jpg": "Royal Blue",
    "6881669b-14c6-49fb-a84c-b9433c52da15.jpg": "Black",
    "6859189c-6771-477c-83cb-528057954dad.jpg": "Black",
    "cb21726c-23fb-455f-94b3-6491c5202d85.jpg": "Royal Blue"
  },
  "women-s-high-waisted-vintage-denim-shorts": {
    "ff28c9d5-d3f2-4f70-9365-cc2aefc9ecb9.jpg": "Light Blue Light Edition",
    "0d4c0f0c-8136-4a45-99aa-c41223dfe90e.jpg": "Black And Gray",
    "55c1f6f6-117a-44ba-9699-7989851e251e.jpg": "Light Blue",
    "14cc2277-46d9-4391-8741-7a7fef4e5a29.jpg": "Deep Blue Light Edition",
    "b4c50b99-93ea-4bbe-b3dd-6561c259b573.jpg": "Dark Blue",
    "ca1737a5-2e9f-465b-8dc3-84ecc3ab3e11.jpg": "Black Grey Light Edition"
  },
  "women-s-square-neck-waist-cinching-top": {
    "0195b9e4-eca3-453a-b857-dedcdf46d598.jpg": "White",
    "78a681ec-a111-4c10-8de4-8d821d870565.jpg": "Black",
    "8cd87039-f1dc-4e3e-96fc-5c52152e1e4c.jpg": "Black"
  },
  "women-s-slim-fit-long-sleeve-top": {
    "dd42dcbd-a70e-4bdc-9997-c9d2b3f0b1d4.jpg": "Black"
  },
  "women-s-casual-cardigan-jogger-set": {
    "0accac1f-4721-4787-adc9-e304895e7ee4.jpg": null,
    "15846ec7-d52e-4a8d-921a-f8680b7fddca.jpg": "Army Green",
    "93d5b466-4702-4c35-8aad-f6a3a4f0b417.jpg": "Black",
    "3404237c-2092-4194-89b5-a4115324521b.jpg": "Brown",
    "cf755b15-b934-4032-9510-8290879cf2b7.jpg": "Blue Gray"
  },
  "women-s-high-waisted-straight-leg-trousers": {
    "9d0e7260-1714-490a-bff4-3bf94300da42.jpg": "Blue",
    "e3fbdef6-2936-42e2-a604-85faf6be5cf1.jpg": "Apricot",
    "6697b5c5-73fc-4573-b38b-e247e51716a1.jpg": "Black",
    "66d94275-ee40-4489-9cf5-5b7a6b2a9531.jpg": "Wine Red",
    "4e816aed-9389-4a74-a7ec-dc2901bba513.jpg": "Apricot"
  },
  "women-s-pleated-wool-blend-wide-leg-pants": {
    "11494b23-d48a-4eec-96ec-2c6248e2910d.jpg": "Black",
    "9e50fce3-bec3-49fb-897b-539697416602.jpg": "Gray",
    "ba25392c-509f-446b-b958-e2202563d3df.jpg": "Gray",
    "32ae80c0-6d07-4d23-aefa-6a943efb0050.jpg": "Gray",
    "b5615622-6c64-495e-bd24-b005f6ef251f.jpg": "Gray",
    "cf44df8b-96ba-4297-8e49-4824053a8bb3.jpg": "Black"
  },
  "women-s-floral-blazer-wide-leg-pants-set": {
    "aab01cac-c338-4abb-9b26-3abf1bb005f9.jpg": "Coffee",
    "97d14191-ed93-49cd-b01d-6026f34ad621.jpg": "Coffee",
    "197e5038-579d-4caa-ba9f-d19f9a3ce984.jpg": null,
    "b52ea0e9-f690-4a60-b2e6-05e8962b9ac5.jpg": "White",
    "b0777300-6969-4cb2-804c-f9d886dee124.jpg": "White"
  },
  "womens-black-slit-denim-skirt": {
    "5890ebc8-834c-4794-b9d6-2510b75dd750.jpg": "8730 Gray Split Stretch Skirt",
    "974ab9d5-a258-4b3b-9ae1-b87e147ca1ef.jpg": "8730 Gray Split Stretch Skirt",
    "d59f136e-68a7-455d-ac95-27d084ae4a1c.jpg": "8730 Gray Split Stretch Skirt",
    "1514c05c-1659-470b-b378-efdf9b79723d.jpg": "8730 Gray Split Stretch Skirt"
  },
  "womens-polka-dot-bow-long-sleeve-blouse": {
    "6553d66b-7b68-4213-8f72-83985491b4b2.jpg": "Brown",
    "d3288fd0-c519-4fa5-bcc4-67a2ee743c1b.jpg": "Brown",
    "2f364f6f-1e09-4544-a00e-911d7d70c1c9.jpg": "Brown",
    "be4e7695-9229-4dd7-b3ae-393f1dc3d5a6.jpg": "Brown",
    "397c5d9f-d5cf-49db-b6fa-2f85243868cf.jpg": "Brown",
    "570e8178-5d4a-42cc-8356-bce44e2e10f4.jpg": "Brown",
    "b8a90bfd-7abc-4e8d-b363-37905a39c3ed.jpg": "Brown",
    "062455d2-a491-482b-8e12-00a42d7acf52.jpg": "Brown"
  },
  "womens-hooded-cinched-cardigan-pants-set": {
    "e7989f7d-6b3a-4629-aee2-dd84f227274a.jpg": "Grey",
    "f173b65a-f10f-4e20-87fb-6acc128c83a8.jpg": "Black",
    "2610ee73-a826-4ddc-8ace-375800457cc3.jpg": "Grey",
    "1e58f2b2-8b06-44b7-97f0-1ddd97fe75f0.jpg": "Grey",
    "04de504f-39dd-4543-bb10-8682c2c60ce1.jpg": "Black",
    "1510ebef-c9bc-40d2-bc84-49ed140c90e4.jpg": "Black",
    "d0e9dde5-1fdc-4767-8fbe-eae9916b2681.jpg": "Apricot"
  },
  "womens-sexy-sleeveless-crop-tank-top": {
    "23a7cf43-bbaf-4993-b239-86f8ac839d84.jpg": null,
    "77c901ba-5c29-4e6c-a4c5-abc3f1f56fd1.jpg": "White",
    "118467b1-f00c-4adb-a4ce-963477cf1017.jpg": "Red",
    "2cf6e68a-3ab5-4012-b469-2545e1b399b5.jpg": "White",
    "d366828b-64b4-4594-83b5-d4f27ee872bd.jpg": "Black",
    "8a84b77e-6a92-46a0-879b-14d01a58013e.jpg": "Black",
    "9ec4bfef-8ff2-4a62-b79c-ca6f952f23d0.jpg": "White",
    "ee8e75df-6812-4f72-8c04-859de6b725f7.jpg": "Red"
  },
  "womens-summer-short-sleeve-t-shirt": {
    "673ca549-3f91-4f5e-8b0d-b5f47ac384d6.jpg": "Red",
    "ea8f8c6e-d092-4efb-abcf-740f1902ee1d.jpg": null,
    "c81a8032-3c97-4f8d-9ab1-7de91dc11eee.jpg": null,
    "9c90d8d3-58d3-4ef4-afc5-53952beeb1c3.jpg": null,
    "2afd1bf3-06bb-4c87-b484-d8f582d7aa63.jpg": "White b"
  },
  "womens-long-sleeve-crop-top": {
    "9695919085268.jpg": null
  },
  "protect-the-ocean-graphic-t-shirt": {
    "3e7f8dbf-5568-4fdd-9a52-d875fe3929f9.jpg": "Black"
  },
  "retro-3d-mushroom-graphic-t-shirt": {
    "1ae2cdc7-45b7-457d-aad9-df00b9408797.jpg": null,
    "8775eed2-9429-4af3-a1ac-c841f999c67c.jpg": null,
    "06983d0f-38d8-47f6-b223-5ef7d781e107.jpg": "White",
    "e1d4fc13-e342-445c-914a-f21c56eaa9d3.jpg": null,
    "258fb892-bed6-4342-8a15-1adbc9eb711e.jpg": "Light Gray"
  },
  "wildflower-graphic-t-shirt-for-women": {
    "70ef130c-fe19-4105-b948-b87c1de54db2.jpg": "White",
    "eedc24cb-5e0f-4e43-a44a-ff6b11563079.jpg": "Khaki"
  },
  "unisex-vintage-denim-workwear-jacket": {
    "87b7d0fa-7e89-42b2-aa12-a1f1c60372e8.jpg": "Do old blue",
    "8a932da6-201e-43b8-9844-397a82bd836e.jpg": "Do old blue"
  },
  "metallic-detail-ribbed-t-shirt": {
    "c6804eee-a7a5-4760-b3eb-1b9c2720c3dd.jpg": "Navy blue",
    "33daed48-fd90-4717-8348-c5035af14314.jpg": "Coffee",
    "23393983-958c-40bf-8f97-a3c3252b75cc.jpg": "Black",
    "e082d269-17cc-4b5d-9f52-4ad85eb61c42.jpg": "Army green",
    "2367a762-c359-42fd-a3e7-b7d1b9c20d94.jpg": "Coffee"
  },
  "shimmering-backless-halter-top": {
    "ec97d3ac-8b08-4b59-83b2-38be1427a2ba.jpg": "Khaki",
    "3ec7fc6a-0187-45ec-96a4-6cbf0f043abe.jpg": "Khaki",
    "2ea4bdfa-2976-43be-98cc-a24be2e18bbe.jpg": "Silver",
    "7c6fdc7b-a13b-4864-8646-e6b749407974.jpg": "Khaki",
    "39f89e87-1131-438c-9b37-c7b00bf4cd72.jpg": "Khaki",
    "ac893c3b-28f6-4a1c-8792-8e1ce04d7863.jpg": "Silver",
    "5b76154e-fc00-426c-911f-954288768f45.jpg": "Black",
    "d4b01c37-b145-4625-96c9-b5567581330a.jpg": "Silver"
  },
  "denim-bandeau-jumpsuit-and-jacket-set": {
    "1900057040257290240.jpg": "Blue",
    "63562728-3709-4a57-bb8b-64c87c44a817.jpg": "Black",
    "1900057049954521088.jpg": "Blue",
    "b0ec176f-e01d-4d18-b214-1b8855d332da.jpg": "Black",
    "1900057054505340928.jpg": "Blue",
    "a4df905c-a937-45aa-a020-ee2dbb18663b.jpg": "Black",
    "1900057044707446784.jpg": "Blue",
    "1900057052135559168.jpg": "Blue"
  },
  "women-s-street-style-straight-pants-suit": {
    "997ddd3f-3a6e-4590-a241-a7fa9e900ce1.jpg": "Blue",
    "a5430338-cd5b-4503-8e71-fae71df3bbb0.jpg": "Blue",
    "b62d92d3-cf33-4be7-a751-3c6184f79802.jpg": "Blue",
    "86283982-8cd1-4e66-9d57-872ec6fa8efc.jpg": "Blue"
  },
  "women-s-vest-and-wide-leg-pants-set": {
    "ccb1c5d8-9981-4b64-97a6-3c19767a1649.jpg": "Dark Blue",
    "2adcdbb7-5832-4f3c-85ee-56c6d4b89aee.jpg": "Brown",
    "26108c58-9d85-4286-84c1-a29d9e2c5380.jpg": "Apricot",
    "fd1ffff8-3998-4c91-aee4-6e504bbcfacb.jpg": "Brown"
  },
  "unisex-relaxed-motorcycle-jacket": {
    "9accc9f4-0aff-4cd2-a43e-ca840dde0472.jpg": "Brown",
    "3785152b-1ede-4b2a-b75d-0003ecc2f099.jpg": "Black",
    "32796b49-2560-4825-aca7-29a7a29b60f6.jpg": null
  },
  "women-s-essential-strapless-tube-top": {
    "4691a7bf-6856-48d3-825b-ff6c0c939c60.jpg": "White",
    "0cbf9bbe-f5c8-4bf6-8814-7eae447d1ee9.jpg": "Black",
    "6f898a48-66d7-4f96-966f-ba195651492a.jpg": "White",
    "9512c485-bf75-480b-95e9-694c83d9887c.jpg": "Red",
    "6b04343d-795a-4458-bda0-33eb34e62b36.jpg": "White"
  },
  "women-s-active-running-set": {
    "c491a916-d6ee-4605-9452-3f2619ed26a1.jpg": "Black Coffee",
    "eb0c90c1-fe1d-4534-a328-1c3e4560b3df.jpg": "Black Coffee"
  },
  "women-s-printed-mesh-matching-set": {
    "bc864f15-1bb8-4152-9438-e7f8ccef98ae.jpg": "Printed Color",
    "98130bbe-4543-442f-ae78-3d9beee83e0c.jpg": "Printed Color",
    "14faf3a2-42a9-43c1-990d-1c15c421c38d.jpg": "Printed Color",
    "f4a90922-97d0-42f1-8778-2b8af0aa3ac8.jpg": "Printed Pink",
    "2ee0c3ef-c18a-4131-9ba8-5885fdeaca69.jpg": "Printed Color"
  },
  "women-s-hollow-out-navy-matching-set": {
    "56b0a643-3e69-48cb-beb9-4eda110c1d6d.jpg": null,
    "fa0330b0-7063-4c98-8098-921c48656613.jpg": "Black",
    "c10f9c89-58f9-49b7-a6fe-f816d76c7749.jpg": "Burgundy",
    "7037802c-a925-4cee-a21b-41a75e96d449.jpg": "Black",
    "6f63b085-3227-44c1-998a-a16b1a4075f1.jpg": "Burgundy"
  },
  "plaid-long-sleeve-overshirt": {
    "b6023288-cbe5-4041-af96-7e4ec914b81c.jpg": "Red",
    "9fef7d7f-24aa-4b0d-b7c4-27769c003807.jpg": "Red",
    "2dd0c7f5-63cc-4d5c-bb17-d8cba32e603b.jpg": "Red",
    "b2c3763b-9d96-4ed5-b454-5c87a7e8e0f7.jpg": "Red"
  },
  "open-chest-zipper-hoodie-top": {
    "45e2a57b-0415-4fdf-a1be-2d7976a53f75.jpg": null
  },
  "creative-3d-trendy-t-shirt": {
    "626ed95e-27e7-450c-83ff-93d659a304f3.jpg": null,
    "a943f59a-888e-4c65-8486-d671bd9f7910.jpg": "Gray"
  },
  "three-bar-wide-leg-cargo-pants": {
    "5e0d2403-eccf-4f4c-8254-4a6195d972c4.jpg": "Blue"
  },
  "womens-vintage-loose-fit-wide-leg-jeans": {
    "08bd2ac0-8a54-4c33-b4fc-e3aee80e5d3b.jpg": "Light Blue",
    "257001d0-65b3-4bc1-8814-eb83c81b999a.jpg": "Light Blue",
    "e4b54a5d-7463-40af-94b7-6c900afeaf73.jpg": "Light Blue",
    "3bdf23ba-3143-439b-8368-4202865fea75.jpg": "Light Blue"
  },
  "vintage-high-waist-straight-leg-loose-jeans": {
    "39aa5348-d600-4061-8e90-31f587834995.jpg": "Deep Retro Blue",
    "fa5f9abf-32b1-42ed-a922-dcb40f4060c5.jpg": "Light Blue",
    "c57fb993-de8e-4f45-90f4-890eb121bcc4.jpg": "Black",
    "3a0a2079-4238-47d6-82dd-9865c07d4389.jpg": "Retro Blue"
  },
  "womens-fitted-lapel-zip-leather-jacket": {
    "215f6908-734a-48d1-8c95-64bc1091c400.jpg": "Black",
    "aedc5bae-b8e4-4433-9319-9d4ebe138a58.jpg": "Black",
    "a6560dc7-bf1a-4c7e-ab09-8456c4d4b707.jpg": "Brown"
  },
  "womens-black-stripe-patchwork-quarter-zip-sweatshirt-pants-set": {
    "4464ab03-946c-4452-872c-b85a0e24d331.jpg": "Black",
    "9ca0979d-407c-4e34-8d0a-0b92ccf2bb00.jpg": "Black",
    "f46feb9e-ae72-4197-a4ad-ab5675079d0a.jpg": "Black"
  },
  "womens-cotton-casual-hoodie-jacket": {
    "a4222c29-1ffc-4e43-bb67-7642fba66ff1.jpg": null,
    "617d0a70-c9ba-4ec0-a81f-00ce4f6ace4d.jpg": null,
    "45fb79f8-a9ba-45e7-8f72-a3b85a3b044b.jpg": "Navy Blue",
    "97c4e836-7576-48b3-a2ab-6556f0fa89a8.jpg": "Milk Tea",
    "02cd7db3-4791-43d0-8e46-465fc02e195c.jpg": "Navy Blue",
    "f7d8ce13-aa97-47bd-94b4-3b19caf82ef9.jpg": null,
    "879b2d43-75a2-46f8-8462-7744d2f0eedd.jpg": "Navy Blue",
    "128c3e93-104b-4a94-95be-34aadcbc96f3.jpg": null
  },
  "womens-unique-long-sleeve-fitness-sports-suit": {
    "31961f09-f253-452d-98e8-6ba606783546.jpg": "Gray"
  },
  "womens-long-sleeve-fitness-yoga-workout-jacket": {
    "f66522ba-fe53-4293-8cc5-f915da1c23da.jpg": "Army Green"
  },
  "womens-long-sleeve-quick-dry-yoga-workout-jumpsuit": {
    "c0d0f8f3-7681-46cf-9253-e8f7e59788bb.jpg": "Haze Blue"
  },
  "womens-shockproof-sports-bra-high-waisted-workout-set": {
    "f76aa850-92c4-43cc-b697-99c0314a5b13.jpg": "Violet",
    "78fa45f8-51fc-4034-8725-4833652cf146.jpg": null,
    "31032653-5015-4947-ae56-ad90dcb4f88a.jpg": "Caramel Mocha",
    "ef79d2e3-07cc-4f6e-8663-ab6202acfaed.jpg": null
  },
  "womens-peach-shaped-butt-lifting-yoga-workout-set": {
    "d9fa01ae-b17c-4cb9-82d3-b519a53ed3ec.jpg": null,
    "dcec9527-37ac-48b6-a908-7cc72c05eca5.jpg": null,
    "899d4983-48cc-4777-bc10-5e224429b8a5.jpg": null,
    "b09986c9-e0c8-4872-a6f8-3f681109fd2e.jpg": "Hermes Orange",
    "5f48bf4d-a743-478f-99fa-55b9842794db.jpg": null
  },
  "mens-child-of-god-oversized-graphic-t-shirt": {
    "8bc07fef-c058-4b89-8b6d-019b720bdc54.jpg": "2Style",
    "60821a04-6135-4f37-8104-8cce4122a49d.jpg": null,
    "e4d64450-f7c5-4194-9e10-fdf9d45d9ae2.jpg": null,
    "3fab96c3-01e4-4b2d-8425-609e4ec775d3.jpg": null
  },
  "womens-retro-stripe-color-block-cropped-sweatpants": {
    "4782cd05-8660-4bba-9170-60c42c92bb89.jpg": "Brown",
    "7e9602da-0538-466a-8cef-363a7531beca.jpg": "Brown",
    "4d4fcd26-5d28-45b1-baff-a4dfece31345.jpg": "Pink",
    "00ebeaa4-3483-4527-adec-26ed0355f314.jpg": "Pink",
    "fd25dc52-7ea1-4b67-b111-031d2737f21e.jpg": "Brown"
  },
  "womens-retro-rivet-straight-leg-sweatpants": {
    "92324c09-7602-4d9d-9d51-c39439fef70d.jpg": "Grey",
    "1e151609-5c1e-4451-aa18-4ed03b0d316c.jpg": "Navy Blue",
    "ede1df80-7724-40a9-88de-e021b830ce00.jpg": "Navy Blue",
    "a4b07262-35b8-4273-9021-cb3295038660.jpg": "Black",
    "7fc8977b-1a44-4cbd-b3fe-d39bcb22cd64.jpg": "Grey"
  },
  "womens-high-waist-loose-fit-jogger-sweatpants": {
    "9facb513-872a-460b-b1fe-5b1c7110edb6.jpg": "Light gray",
    "b79dd9c9-bedd-4d7d-b76d-effb0500e9d7.jpg": "Light gray",
    "f8f46388-a906-4cab-bc36-33f390dff900.jpg": "Dark gray",
    "62a1c7d7-9971-4810-87f4-4b366d8fc824.jpg": "Dark gray"
  }
};
  var uncertainPhotos = {"wildflower-graphic-t-shirt-for-women": ["ecc4d25c-7475-4dcf-889d-2e74a7a9c94d.jpg"]};

  function all(selector, root) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }
  function filename(src) {
    try {
      return decodeURIComponent(new URL(src, window.location.href).pathname.split('/').pop())
        .replace(/_(?:\d+x\d*|\d*x\d+)(?=\.[^.]+$)/, '');
    } catch (error) { return ''; }
  }
  function readJson(selector, root) {
    var node = root.querySelector(selector);
    try { return node ? JSON.parse(node.textContent) : []; }
    catch (error) { return []; }
  }
  function message(root, text) {
    var node = root.querySelector('[data-gallery-color-message]');
    if (!node) {
      node = document.createElement('p');
      node.setAttribute('data-gallery-color-message', '');
      node.setAttribute('role', 'status');
      node.className = 'mt-4 text-sm text-muted';
      var form = root.querySelector('#CarqProductForm');
      if (!form) return;
      form.insertBefore(node, form.firstChild);
    }
    node.textContent = text || '';
    node.hidden = !text;
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var thumb = event.target.closest('[data-product-thumb]');
    if (!thumb) return;
    var root = thumb.closest('[data-product-root]');
    if (!root) return;
    var image = thumb.querySelector('img');
    var main = root.querySelector('[data-product-gallery] img');
    if (!image || !main) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    var match = window.location.pathname.match(/\/products\/([^/]+)/);
    var handle = match ? decodeURIComponent(match[1]) : '';
    var key = filename(image.currentSrc || image.src);
    var photos = reviewedPhotos[handle] || {};
    if (uncertainPhotos[handle] && uncertainPhotos[handle].indexOf(key) !== -1) {
      message(root, 'Please choose a color below. This photo has not been matched to a color.');
      return;
    }
    var groups = all('[data-option-group]', root);
    var colourGroup = groups.filter(function (group) {
      return group.querySelector('[data-option-value] .sr-only');
    })[0];
    var variants = readJson('[data-product-variants]', root);
    var neutral = Object.prototype.hasOwnProperty.call(photos, key) && photos[key] === null;
    var colour = photos[key];

    if (colourGroup && !neutral) {
      var position = Number(colourGroup.dataset.optionPosition);
      var buttons = all('[data-option-value]', colourGroup);
      if (!colour) {
        var alt = (thumb.dataset.mediaAlt || '').trim().toLowerCase();
        var altButton = buttons.filter(function (button) {
          return button.dataset.value.trim().toLowerCase() === alt;
        })[0];
        if (altButton) colour = altButton.dataset.value;
      }
      if (!colour) {
        var linked = [];
        readJson('[data-product-media-map]', root).forEach(function (entry) {
          if (String(entry.featured_media_id) !== String(thumb.dataset.mediaId)) return;
          var variant = variants.filter(function (item) {
            return String(item.id) === String(entry.id);
          })[0];
          if (variant && linked.indexOf(variant.options[position]) === -1) {
            linked.push(variant.options[position]);
          }
        });
        if (linked.length === 1) colour = linked[0];
      }
      if (colour) {
        var button = buttons.filter(function (item) { return item.dataset.value === colour; })[0];
        if (!button) {
          message(root, 'Please choose a color below. The available colors have changed.');
          return;
        }
        var selected = [];
        groups.forEach(function (group) {
          var active = group.querySelector('[data-option-value][aria-pressed="true"]');
          selected[Number(group.dataset.optionPosition)] = active ? active.dataset.value : null;
        });
        selected[position] = colour;
        var combination = variants.some(function (variant) {
          return variant.options.every(function (value, index) {
            return selected[index] == null || selected[index] === value;
          });
        });
        if (!combination) {
          message(root, 'This color is not offered in the selected size. Choose another size first.');
          return;
        }
        /* Reuse the theme's selection handler to update the purchased variant,
           price, stock, label, and both add-to-cart buttons together. */
        button.click();
      }
    }

    message(root, '');
    all('[data-product-thumb]', root).forEach(function (item) {
      var active = item === thumb;
      item.classList.toggle('ring-1', active);
      item.classList.toggle('ring-ink', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    var src = new URL(image.currentSrc || image.src, window.location.href);
    src.searchParams.set('width', '1400');
    main.src = src.href;
    main.alt = thumb.dataset.mediaAlt || colour || image.alt || '';
  }, true);
})();
